import type { StorePageConfig } from '@/app/(football)/[team]/store/_context/types';

export const dhcfcConfig: StorePageConfig = {
  titleSection: {
    title: '스토어',
    highlight: '오직 팬카드에서만!',
    description: '한정판 디지털 에디션을 만나보세요.',
  },
};
